import { render } from "./ClaimsTab.vue?vue&type=template&id=be00449e"
import script from "./ClaimsTab.vue?vue&type=script&lang=js"
export * from "./ClaimsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__